import { useState } from "react";
import formatDate from "../utils/formatDate";

/**
 *
 * @returns una fecha de inicio y una de fin. Tambien un mutador
 */
export const useDate = () => {
  const [arrData, setArrData] = useState([]);
  const [tag, setTag] = useState("");
  const [isData, setIsData] = useState(false);

  /**
   * Setea los valores de data y tag
   * @param {*} data
   * @param {*} tag
   */
  const setDateHook = (data = [], tag = "") => {
    if (data.length <= 0 || tag === "") {
      setIsData(false);
    } else {
      setArrData(data);
      setTag(tag);
      setIsData(true);
    }
  };

  /**
   *
   * @returns retorna fecha inicial
   */
  const startDate = () => {
    if (isData) {
      const { Fecha, fecha } = arrData
        .filter((element) => element.Detalle === tag)
        .shift();

      if (Fecha) {
        return formatDate(Fecha);
      } else if (fecha) {
        return formatDate(fecha);
      }
    } else {
      return "no start date";
    }
  };

  /**
   *
   * @returns retorna fecha final
   */
  const endDate = () => {
    if (isData) {
      const { Fecha, fecha } = arrData
        .filter((element) => element.Detalle === tag)
        .pop();

      if (Fecha) {
        return formatDate(Fecha);
      } else if (fecha) {
        return formatDate(fecha);
      }
    } else {
      return "no end data";
    }
  };

  /**
   *
   * @returns retorna fecha completa
   */
  const fullDate = () => {
    if (isData) {
      return startDate() + " - " + endDate();
    }

    return "no full date";
  };

  return { startDate, endDate, setDateHook, fullDate };
};
